// extracted by mini-css-extract-plugin
export var clarsyntPostCard = "post-card-module--clarsynt-post-card--168T7";
export var clarsyntPostCardContent = "post-card-module--clarsynt-post-card-content--3VKa_";